import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { useSuccessPage, useWelcomePage } from 'components/auth/utils/utils';
import WSChat from 'components/chat/WSChat';
import { InfoPage } from 'components/common/Layout/InfoPage/InfoPage';
import Popup from 'components/common/Popup/Popup';
import SnackBar from 'components/common/SnackBar/SnackBar';
import AuthPromoBanner from 'components/utils/AuthPromoBanner';
import ModalWithTimer from 'components/utils/ModalWithTimer';
import Spinner from 'components/utils/Spinner';

import { toggleModal, toggleNavBar } from 'actions/appAction';
import { updateExtraByName } from 'actions/extraAction';

import { FRAUD_BLOCK_DISCLAIMER_MODAL, FRAUD_BLOCK_INFO_MODAL } from 'constants/ComponentNames';
import { USA } from 'constants/WellKnownCountries';

import { findErrorCodeAndMessage, showErrorType } from 'helpers/utils';

import { useExtra, usePageMessages } from 'hooks/selectors';

import { MainColumn } from './MainColumn/MainColumn';
import { StubPage } from './StubPage';
import FraudBlockDisclaimer from '../../auth/common/FraudMonitoring/FraudBlockDisclaimer';
import FraudBlockInfoModal from '../../auth/common/FraudMonitoring/FraudBlockInfoModal';
import CloudFlareModal from '../../auth/common/modal/CloudFlareModal';
import WelcomePage from '../../auth/history/send/WelcomePage';
import MessageBodyService from '../../utils/MessageBodyService';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    pointer-events: ${(props) => (props.isShowSpinner ? 'none' : null)};
    opacity: ${(props) => (props.isShowSpinner ? '0.3' : null)};

    & > form {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
    }

    & > div {
        filter: ${(props) => (props.isShowSpinner ? 'blur(2px)' : null)};
    }
`;

const BaseLayout = (props) => {
    const [modal, setModal] = useState(FRAUD_BLOCK_INFO_MODAL);
    const { successTitle } = usePageMessages();
    const [showSuccess] = useSuccessPage(props);
    const [showWelcomePage, toggleWelcomePage] = useWelcomePage(props);
    const { gaServerNotAvailable } = useExtra();
    const isUsaUser = props.userCountryId === USA;

    useEffect(() => {
        const errorType = showErrorType(props.messageBodyError, props.serverErrors, props.cheque, props.paymentStatus, props.serverErrorCode);
        if (errorType || props.showFrozenListDisclaimer) {
            toggleModal(errorType);
        }
    }, [props.messageBodyError, props.serverErrors, props.cheque, modal, props.showFrozenListDisclaimer, props.paymentStatus, props.serverErrorCode]);

    const toggleModal = (errorType) => {
        const error = findErrorCodeAndMessage(props.messageBodyError, props.serverErrors, props.cheque, props.paymentStatus, props.serverErrorCode);
        if (modal === FRAUD_BLOCK_INFO_MODAL) {
            props.toggleModal(true, <FraudBlockInfoModal setModal={setModal} errorType={errorType} error={error} isUsaUser={isUsaUser} />);
        } else if (modal === FRAUD_BLOCK_DISCLAIMER_MODAL) {
            props.toggleModal(true, <FraudBlockDisclaimer setModal={setModal} errorType={errorType} error={error} isUsaUser={isUsaUser} />);
        }
    };

    const getRenderComponent = () => {
        if (gaServerNotAvailable && props?.stateOptions?.isGA) {
            return (
                <MainColumn>
                    <StubPage />
                </MainColumn>
            );
        } else if (!props.loading) {
            return <>{props.children}</>;
        } else {
            return false;
        }
    };

    if (showWelcomePage) {
        return <WelcomePage hideWelcomePage={() => toggleWelcomePage(false)} />;
    } else if (showSuccess) {
        return <InfoPage animatedIconSuccess mainText={successTitle} />;
    } else {
        return (
            <>
                {props.showPromoBanner && <AuthPromoBanner />}
                <Wrapper data-testid={props.dataTestId}>
                    {getRenderComponent()}
                    {props.isShowModal && props.modalComponent}
                    {props.isShowModalWithTimer && <ModalWithTimer />}
                    {props.isShowCloudFlareModal && <CloudFlareModal />}
                    <SnackBar />
                    <Popup />
                    <MessageBodyService />
                    <Spinner />
                    <WSChat />
                </Wrapper>
            </>
        );
    }
};
const mapStateToProps = ({ app, auth, extra, history, login }) => {
    return {
        serverErrors: app.errors,
        messageBodyError: app.messageBody,
        isShowPopup: app.isShowPopup,
        modalComponent: app.modalComponent,
        isShowModal: app.isShowModal,
        isShowModalWithTimer: app.isShowModalWithTimer,
        isShowCloudFlareModal: app.cloudFlareModal?.isShow,
        userCountryId: auth.countryId,
        defaultCountry: extra.defaultCountry,
        isShowSuccess: extra.isShowSuccess,
        showWelcomePage: extra.welcomePage,
        showFrozenListDisclaimer: extra.showFrozenDisclaimer,
        paymentStatus: extra.payment_status,
        serverErrorCode: extra.serverErrorCode,
        cheque: history?.cheque?.cheque,
        loginCountryCode: login?.countryCode,
    };
};
BaseLayout.propTypes = {
    showPromoBanner: PropTypes.bool,
    loading: PropTypes.bool,
    isShowModalWithTimer: PropTypes.bool,
    isShowCloudFlareModal: PropTypes.bool,
};

export default connect(mapStateToProps, {
    toggleModal,
    toggleNavBar,
    updateExtraByName,
})(BaseLayout);
